import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CONSENT_EVENT, getConsent, setConsent } from "@/lib/consent";
import { SITE } from "@/lib/site";

const CookieBanner = () => {
  const [consent, setConsentState] = useState(getConsent);

  useEffect(() => {
    const sync = () => setConsentState(getConsent());
    window.addEventListener(CONSENT_EVENT, sync);
    return () => window.removeEventListener(CONSENT_EVENT, sync);
  }, []);

  if (consent) return null;

  return (
    <div
      role="region"
      aria-label="Aviso de cookies"
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#1A2B56] text-slate-200 border-t border-white/10 shadow-[0_-8px_30px_rgba(0,0,0,0.25)]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-sm leading-relaxed md:flex-1">
          Usamos cookies e tecnologias semelhantes para entender como o site é
          usado e melhorar sua experiência, conforme a LGPD. Saiba mais na
          nossa{" "}
          <Link
            to={SITE.privacyPath}
            data-testid="cookie-banner-policy-link"
            className="font-semibold text-white underline underline-offset-4 hover:text-[#e63946] transition-colors"
          >
            Política de Privacidade
          </Link>
          .
        </p>
        <div className="flex gap-3 shrink-0">
          <Button
            type="button"
            variant="outline"
            onClick={() => setConsent("rejected")}
            data-testid="cookie-banner-reject"
            className="flex-1 md:flex-none bg-transparent border-white/40 text-white hover:bg-white/10 hover:text-white rounded-sm h-11 px-5 font-semibold text-sm"
          >
            Recusar
          </Button>
          <Button
            type="button"
            onClick={() => setConsent("accepted")}
            data-testid="cookie-banner-accept"
            className="flex-1 md:flex-none bg-[#e63946] hover:bg-[#c92a36] text-white rounded-sm h-11 px-5 font-bold text-sm"
          >
            Aceitar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
